// v1.0.4
import React, { useEffect, useState } from "react";
import { trackPage, resolvePageName } from "./services/sessionLogger";
import axios from "./axios";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import Dashboard from "./Dashboard";
import PublicProductsPage from "./pages/PublicProductsPage";
import PublicProductPage from "./pages/PublicProductPage";
import DOMDebugger from "./DOMDebugger";
import ClientSocketListener from "./pages/ClientSocketListener";
import ClientHistory from "./pages/ClientHistory";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import QrScanner from "./components/QrScanner";
import AboutPage from "./pages/AboutPage";
import ClientMap from "./pages/ClientMap";
import VendorProducts from "./pages/VendorProducts";
import Feedback from "./pages/Feedback";
import MesProduits from "./pages/MesProduits";
import MentionsPage from "./pages/MentionsPage";
import PrivacyPage from "./pages/PrivacyPage";
import MentionsLegales from "./pages/MentionsLegales";
import FAQPage from "./pages/FAQPage";
import EvolutionsPage from "./pages/EvolutionsPage";
import SuperAdmin from "./pages/SuperAdmin";
import RecoverPage from "./pages/RecoverPage";
import MyDataPage from "./pages/MyDataPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import GlobalProductPage from "./pages/GlobalProductPage";
import CrushPublicPage from "./pages/CrushPublicPage";
import CommunityProductPage from "./pages/CommunityProductPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import RecoverAccountPage from "./pages/RecoverAccountPage";
import WelcomeModal from "./components/WelcomeModal";
import CookieBanner from "./components/CookieBanner";
import { registerPushToken } from "./notifications"; // ✅ Ajouté ici
import Footer from "./components/Footer";
import './App.css';
import './index.css';

import 'leaflet/dist/leaflet.css';
import "react-toastify/dist/ReactToastify.css";

  function App() {
    const [showMaintenanceBanner, setShowMaintenanceBanner] = useState(false);

    useEffect(() => {
      fetch("https://www.crush-now.fr/api/admin/config", {
        headers: { "x-admin-key": process.env.REACT_APP_ADMIN_SECRET_KEY || "" }
      })
        .then(res => res.json())
        .then(data => setShowMaintenanceBanner(!!data.maintenance_banner))
        .catch(() => setShowMaintenanceBanner(false));
    }, []);

    useEffect(() => {
      const interval = setInterval(() => {
        fetch("/health")
          .then(() => console.log("✅ Ping /health pour garder le backend actif"))
          .catch(() => console.warn("⚠️ Ping échoué"));
      }, 5 * 60 * 1000); // Toutes les 5 minutes

      return () => clearInterval(interval);
    }, []);
    const navigate = useNavigate();
    const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      const storedUser = localStorage.getItem("user");
      const user = storedUser ? JSON.parse(storedUser) : null;

      if (typeof Notification !== "undefined") {
        if (user?.subscribedToPush && Notification.permission !== "granted") {
          Notification.requestPermission().then(function (permission) {
            if (permission === "granted") {
              console.log("✅ Notifications autorisées !");
              navigator.serviceWorker.ready.then(function (registration) {
                registration.showNotification("Crush Me 💌", {
                  body: "Merci d'avoir accepté les notifications 🎉",
                  icon: "/favicon.ico",
                  badge: "/favicon.ico",
                  vibrate: [200, 100, 200],
                  data: { dateOfArrival: Date.now(), primaryKey: 1 },
                  actions: [
                    { action: "explore", title: "Voir" },
                    { action: "close", title: "Fermer" },
                  ],
                });
              });
            } else {
              console.log("❌ L'utilisateur a refusé les notifications");
            }
          });
        } else {
          console.log("🔕 Notifications désactivées ou déjà refusées");
        }
      }
    }, 10000);

    return () => clearTimeout(timer);
  }, []);

  const [user, setUser] = useState(null);
  const [authReady, setAuthReady] = useState(false);

  // Session restoration — verifie le token au demarrage via /auth/me
  useEffect(() => {
    const stored = (() => {
      try { return JSON.parse(localStorage.getItem("user") || "null"); }
      catch { return null; }
    })();

    if (!stored?.token) {
      setAuthReady(true);  // pas de token -> inutile d'appeler /auth/me
      return;
    }

    axios.get("/auth/me")
      .then(res => {
        setUser({ ...stored, ...res.data });
      })
      .catch((err) => {
        const status = err?.response?.status;
        if (status === 401 || status === 403) {
          // Token invalide/expire -> deconnecter proprement
          localStorage.removeItem("user");
          setUser(null);
        } else {
          // Erreur reseau, timeout, cold start Railway -> garder la session locale
          setUser(stored);
        }
      })
      .finally(() => setAuthReady(true));
  }, []);

  // Re-sync page tracking a chaque changement de route
  useEffect(() => {
    trackPage(resolvePageName(location.pathname));
  }, [location.pathname]);

  // Re-sync user quand localStorage change dans un autre onglet
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "user") {
        try {
          setUser(e.newValue ? JSON.parse(e.newValue) : null);
        } catch {
          setUser(null);
        }
      }
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  useEffect(() => {
    const uid = user?._id || user?.id;
    if (uid) registerPushToken(uid);
  }, [user]);


  const [scannedProducts, setScannedProducts] = useState([]);

  useEffect(() => {
    const fetchScannedProducts = async () => {
      if (user?._id) {
        try {
          const response = await axios.get(`/scans/history/${user._id}`);
          setScannedProducts(response.data);
        } catch (error) {
          const status = error?.response?.status;
          if (status !== 401 && status !== 403) {
            console.warn("⚠️ fetchScannedProducts échoué silencieusement", error.message);
          }
        }
      }
    };

    fetchScannedProducts();
  }, [user]);

  const allowedGuestRoutes = [
    "/register",
    "/login",
    "/",
    "/scan",
    "/products",
    "/about",
    "/cgu",
    "/legal",
    "/mentions",
    "/privacy",
    "/mentions-legales",
    "/landing",
    "/feedback",
    "/recover",
    "/forgot-password",
    "/reset-password",
    "/recover-account",
    "/faq",
    "/evolutions"
  ];

  const path = location.pathname;

  // Pendant la verification de session : splash screen (tous les hooks deja appeles)
  if (!authReady) return (
    <div style={{
      minHeight: "100vh", background: "#D41A6E",
      display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center", gap: "14px"
    }}>
      <div style={{
        width: "36px", height: "36px",
        border: "3px solid rgba(255,255,255,0.3)",
        borderTopColor: "white",
        borderRadius: "50%",
        animation: "spin 0.75s linear infinite"
      }} />
      <p style={{ color: "white", fontSize: "14px", fontWeight: 500 }}>
        Chargement...
      </p>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );

  // Apres la verification : guard avec user fiable
  if (
    !user &&
    !(
      allowedGuestRoutes.includes(path) ||
      path.startsWith("/product/") ||
      path.startsWith("/barcode/") ||
      path.startsWith("/community-product/") ||
      path.startsWith("/c/")
    )
  ) {
    window.location.href = "/login";
  }

  // Redirection intelligente : user connecte sur landing -> son espace
  if (user && (path === "/" || path === "/landing")) {
    navigate(user.role === "vendeur" ? "/dashboard" : "/client", { replace: true });
  }


            return (
              <>
                {showMaintenanceBanner && (
                  <div style={{
                    position: "fixed", top: 0, left: 0, right: 0, zIndex: 9999,
                    height: "36px", background: "#1e293b", color: "white",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: "12px", fontFamily: "system-ui, -apple-system, sans-serif",
                    padding: "0 16px", textAlign: "center",
                  }}>
                    🔧 Améliorations en cours — des petits bugs peuvent survenir, merci pour votre patience&nbsp;!
                  </div>
                )}

                <div style={showMaintenanceBanner ? { paddingTop: "36px" } : {}}>

                <div className="min-h-screen bg-[#F8FAFC] font-sans antialiased text-slate-900">
                  <WelcomeModal />
                  <CookieBanner />
                  <DOMDebugger />
                  <ClientSocketListener scannedProducts={scannedProducts} user={user} />

                  <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/register" element={<RegisterPage />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/client" element={<ClientHistory user={user} onUserUpdate={setUser} />} />
                    <Route path="/products" element={<PublicProductsPage />} />
                    <Route path="/product/:productId" element={<PublicProductPage />} />
                    <Route path="/community-product/:id" element={<CommunityProductPage />} />
                    <Route path="/scan" element={<QrScanner />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/cgu" element={<MentionsLegales />} />
                    <Route path="/legal" element={<MentionsLegales />} />
                    <Route path="/map" element={<ClientMap scans={scannedProducts} />} />
                    <Route path="/mes-produits" element={<VendorProducts />} />
                    <Route path="/mentions" element={<MentionsPage />} />
                    <Route path="/privacy" element={<PrivacyPage />} />
                    <Route path="/faq" element={<FAQPage />} />
                    <Route path="/evolutions" element={<EvolutionsPage />} />
                    <Route path="/mentions-legales" element={<MentionsLegales />} />
                    <Route path="/landing" element={<LandingPage />} />
                    <Route path="/feedback" element={<Feedback />} />
                    <Route path="/superadmin" element={<SuperAdmin />} />
                    <Route path="/recover" element={<RecoverPage />} />
                    <Route path="/my-data" element={<MyDataPage />} />
                    <Route path="/barcode/:barcode" element={<GlobalProductPage />} />
                    <Route path="/c/:slug" element={<CrushPublicPage />} />
                    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                    <Route path="/reset-password" element={<ResetPasswordPage />} />
                    <Route path="/recover-account" element={<RecoverAccountPage />} />
                  </Routes>

                  {/* Masqué sur /client, /dashboard, /about, /my-data : ces pages ont leur propre footer */}
                  {!["/client", "/dashboard", "/about", "/", "/my-data"].includes(location.pathname) && <Footer />}
                </div>

                {/* Container global des toasts */}
                <ToastContainer
                  position="top-right"
                  autoClose={5000}
                  hideProgressBar={false}
                  newestOnTop={true}
                  closeOnClick
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  theme="colored"
                  limit={3}
                />
                </div>
              </>
            );
}

export default App;